$(document).ready(function() {
  $('.logolist__holder').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
  });  
  $('.grid__section .grid').slick({
    slidesToShow: 6,
    slidesToScroll: 6,
    infinite: false,
    arrows: false,
     responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    }
       ]
    });
  $('.puzzle-item').click(function() {
    $('.puzzle-item').removeClass('active');
    $(this).addClass('active');
    var url = $(this).find('.puzzle-piece').attr('data-url');
    $('.puzzle-btn a').attr('href', url);
  });
});

